import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../app/context/cart-context/cart-context";
import { motion } from "framer-motion";
import ApiServices from "../../service/ApiServices";
import { useUser } from "../../app/context/user-context/user-context";

import { CheckoutForm } from "./form/checkout-form";
import { FullName } from "./inputs/full-name";
import { Phone } from "./inputs/phone";
import { Address } from "./inputs/address";
import { OrderComment } from "./inputs/comment";
import { Payments } from "./inputs/payments";
import { CashRadio } from "./inputs/payments/cash-radio";
import { CardRadio } from "./inputs/payments/card-radio";
import { LiqpayRadio } from "./inputs/payments/liqpay-radio";
import { Offer } from "./inputs/offer";
import { When } from "./inputs/when/when";

import './shipping.css';
import { ShippingMethods } from "./inputs/shipping-methods";
import { useSettings } from "../../app/context/settings-context/settings-context";

export const Shipping = () => {

    const [form, setForm] = useState(false);

    const thisCustomer = useUser();

    const {customer} = thisCustomer;

    const { cartId } = useCart();

    const res = new ApiServices()

    const navigate = useNavigate();

    const [ship, setShip] = useState(true);

    const {settings: {payment, orderTypes}} = useSettings();
    useEffect(() => {
        if (form) {
            const payment = localStorage.getItem('payment');

            if(payment === "cash" || payment === "card") {
                res.createOrder()
                .then(data => {
                    if (data === 'Success') {

                        return navigate(`/success/${cartId}`);
                    }
                })
                .catch(error =>  navigate(`/failure/${cartId}`)) 
            } else if (payment === "liqpay") {
                return navigate('/checkout');
            }
            setForm(false);
        }
    },[form]);

    const handleCheckoutForm = (data) => {
        setForm(data);
    }

    return (
        <motion.div className="container"
            initial={{opacity: 0}}
            animate={{opacity: 1, transition: {duration: 0.5}}}
            exit={{opacity: 0, transition: {duration: 0.1}}}
        >
            <div className="row">
                <h2 className="mt-4">Оформлення замовлення</h2>
                <CheckoutForm onCheckoutForm={handleCheckoutForm}>
                    <Phone value={customer.phone}/>
                    <FullName value={customer.name}/>
                    {orderTypes &&
                        <ShippingMethods onSetShip={setShip} methods={orderTypes}/>
                    }
                    {ship && customer &&
                            <Address value={customer?.address}/>
                    }
                    <When/>
                    <OrderComment/>
                    <Offer/>
                    {payment &&
                       <Payments payment={payment}/>
                    }
                </CheckoutForm>
            </div>
        </motion.div>
    )
}